import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';

import styles from './Accordion.module.css';

export const Accordion = (props) => {
    const [openedIndex, setOpenedIndex] = useState(null);
    const showHideAccordion = (e, index) => {
        e.preventDefault();
        if (index === openedIndex) {
            setOpenedIndex(null);
        } else {
            setOpenedIndex(index);
        }
    };
    const toggleItem = (e, index, id) => {
        e.preventDefault();
        if (index === openedIndex) {
            setOpenedIndex(null);
        } else {
            setOpenedIndex(index);
        }
        props.sendEvent?.(id);
    };

    return (
        <ul className={`${styles.accordionList} ${props.isCompact ? styles.accordionListCompact : ''}`}>
            {props.items
                .filter((item) => item !== null)
                .map((item, index) => {
                    return (
                        <li key={index}>
                            <a
                                className={`${styles.accordionHeader} ${props.promoDarkPage ? styles.accordionHeaderDark : ''}`}
                                tabIndex={'0'}
                                onClick={(e) => toggleItem(e, index, item.id)}
                                onKeyPress={(e) => showHideAccordion(e, index)}
                            >
                                {item.header}
                                <span className={styles.accordionIcon}>
                                    <PromoIcon
                                        name={openedIndex === index ? 'minus' : 'plus'}
                                        size="24px"
                                        color={props.promoDarkPage ? 'white' : 'baseColor'}
                                    />
                                </span>
                            </a>
                            {openedIndex === index && (
                                <div className={`${styles.accordionContent} ${props.contentNoPadding ? styles.accordionContentNoPadding : ''}`}>
                                    {item.content}
                                </div>
                            )}
                        </li>
                    );
                })}
        </ul>
    );
};

Accordion.propTypes = {
    items: PropTypes.array,
    contentNoPadding: PropTypes.bool,
    promoDarkPage: PropTypes.bool,
    isCompact: PropTypes.bool,
};
